module.exports = __webpack_public_path__ + "static/media/service-contract-report.52cf0cc7.svg";